import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterLink } from '@angular/router';

import { IrisIconComponent } from '@sondermind/iris/icon';
import { IrisIconButtonModule } from '@sondermind/iris/icon-button';
import { IrisCardModule } from '@sondermind/iris/card';

import { IrisMenuComponent } from './menu.component';

@NgModule({
  declarations: [
    IrisMenuComponent
  ],
  imports: [
    CommonModule,
    RouterLink,
    IrisIconComponent,
    IrisIconButtonModule,
    IrisCardModule
  ],
  exports: [
    IrisMenuComponent
  ]
})
export class IrisMenuModule { }
